import React from 'react';
import { Box, TextInput, Group, ActionIcon, Textarea, Divider } from '@mantine/core';
import { X, Plus } from 'tabler-icons-react';

function ResolutionProblemeEpreuve({ form, index, onRemove }) {
    // Debugging: Log the current value of consigne
    console.log(`Current consigne value for index ${index}:`, form.values.epreuves[index].consigne);
    console.log("Current operations value " + form.values.epreuves[index].correction_dp)

    return (
        <Box key={index}>
            <TextInput
                placeholder="Mettre la consigne"
                mb={10}
                radius={10}
                {...form.getInputProps(`epreuves.${index}.titre`)}
            />
            <Textarea
                placeholder="Écrire la consigne"
                mb={10}
                radius={10}
                autosize
                minRows={3}
                value={typeof form.values.epreuves[index].consigne === 'string' ? form.values.epreuves[index].consigne : form.values.epreuves[index].consigne[0]}
                onChange={(event) => form.setFieldValue(`epreuves.${index}.consigne`, event.currentTarget.value)}
            />
            <Group position="apart">
                <Group>
                    {form.values.epreuves[index].correction_dp.map((item, idx) => (
                        <div key={idx} style={{ display: 'flex', alignItems: 'center' }}>
                            <TextInput
                                placeholder="Opération"
                                radius={10}
                                value={item}
                                onChange={(event) => form.setFieldValue(`epreuves.${index}.correction_dp.${idx}`, event.currentTarget.value)}
                                w={150}
                            />
                        </div>
                    ))}
                    <ActionIcon
                        color="green"
                        onClick={() => form.insertListItem(`epreuves.${index}.correction_dp`, "")}
                    >
                        <Plus size="1rem" />
                    </ActionIcon>
                </Group>
                <ActionIcon color="red" onClick={() => onRemove(index)}>
                    <X size="1rem" />
                </ActionIcon>
            </Group>
            <Divider my={20} />
        </Box>
    );
}

export default ResolutionProblemeEpreuve; 